/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileCommitmentMultipleToActivityRequest } from '../../models/profile-commitment-multiple-to-activity-request';

export interface AssignCommitmentsToActivity$Params {
      body: ProfileCommitmentMultipleToActivityRequest
}

export function assignCommitmentsToActivity(http: HttpClient, rootUrl: string, params: AssignCommitmentsToActivity$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, assignCommitmentsToActivity.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

assignCommitmentsToActivity.PATH = '/rest/profile/commitment/assign-commitments-to-activity';
